import {
  type SupportedContentTypeCategory,
  contentTypeCategoryToLabel,
  supportedContentTypeCategories,
} from '@carboncopyco/editor-utils';
import { DropdownFilter, TextBase } from '@carboncopyco/ui';
import { useState } from 'react';

type ResponseTypeFilterProps = {
  onChange: (filters: SupportedContentTypeCategory) => void;
  contentTypeCategory?: SupportedContentTypeCategory;
};

export const ResponseTypeCategoryFilter = ({
  onChange,
  contentTypeCategory = 'json',
}: ResponseTypeFilterProps) => {
  const [filter, setFilter] =
    useState<SupportedContentTypeCategory>(contentTypeCategory);

  const onSelect = (filter: SupportedContentTypeCategory) => {
    setFilter(filter);
    onChange(filter);
  };

  return (
    <div className="flex items-center gap-1.5">
      <TextBase
        label="Response type:"
        color="text-ds-natural-600"
      />
      <DropdownFilter<SupportedContentTypeCategory>
        placeholder="Content Type"
        onSelect={onSelect}
        selected={filter}
        contentWidth={200}
        items={supportedContentTypeCategories.map((category) => ({
          id: category,
          label: contentTypeCategoryToLabel[category],
        }))}
      />
    </div>
  );
};
